<template>
  <div>
    <el-dialog
      title="富文本配置"
      width="50%"
      top="2%"
      :visible.sync="dialogVisible"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <!-- <el-button type="warning" size="medium" @click="openAddImg"
        >图片上传</el-button
      > -->
      <el-button type="success" size="medium" @click="openLook"
        >预览页面</el-button
      >
      <el-button type="danger" size="medium" @click="handleCope"
        >复制图文</el-button
      >
      <el-button type="primary" size="medium" @click="handleSubmit"
        >保存</el-button
      >
      <br /><br />
      <div ref="content" id="wangEditor" class="wangEditor"></div>
    </el-dialog>
    <el-dialog
      title="上传图片"
      :visible.sync="dialogVisibleAddImg"
      width="800px"
      @close="handleAddImgClose"
      :close-on-click-modal="false"
      style="height:500px"
    >
      <el-form ref="form" :model="editParam" label-width="300px">
        <div class="form-flex-box">
          <el-form-item label="" prop="cover">
            <el-upload
              class="upload-demo"
              name="upload"
              accept="image/jpeg, image/png, image/jpg, image/gif, image/webp"
              :action="action"
              :headers="header"
              :on-success="imageUploadSuccess"
              :on-error="imageUploadFail"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <decrypt-img
              v-if="editParam.cover"
              style="height: 100px"
              :src="handleImageUrl(editParam.cover)"
              :preview-src-list="[handleImageUrl(editParam.cover)]"
            >
            </decrypt-img>
          </el-form-item>
        </div>
        图片地址:
        <span>{{ editParam.cover ? handleImageUrl(editParam.cover) : null }}</span>
      </el-form>
    </el-dialog>

    <rich-preview ref="preview"></rich-preview>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
import RichPreview from "@/components/rich-preview/index.vue";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import videoApi from "@/api/videoManagement";
const isBlobUrl = (url) => /^blob:(https?|file):/.test(url);

const observedElements = [];
let observer = null;

export default {
  components: { RichPreview },
  props: {
    isDataFill: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleLook: false,
      dialogVisibleAddImg: false,
      editor: null,
      editorData: "",
      id: "",
      richText: "",
      cope_rich_text: "",
      data: "",
      video: null, //视频对象
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/upload/image",
      header: {
        Authorization: local.get("userInfo").token,
      },
      editParam: {
        imgUrl: baseConfig.imgUrl,
        cover: "",
      },
      copySrc: "",
    };
  },
  created() {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.observeEntry(entry);
        });
      },
      { threshold: 0.1 }
    );
  },
  mounted() {
    // 监听 copy 事件
    // document.addEventListener("copy", this.handleCopy);
  },
  beforeDestroy() {
    this.unobserveImages();
    observer.disconnect();
    // 移除事件监听
    // document.removeEventListener("copy", this.handleCopy);
  },
  methods: {
    // handleCopy(event) {
    //   const newHtml = event.target.outerHTML;
    //   const parser = new DOMParser();
    //   const doc = parser.parseFromString(newHtml, "text/html");
    //   if (
    //     doc.getElementsByTagName("img") &&
    //     doc.getElementsByTagName("img").length
    //   ) {
    //     this.copySrc = doc.getElementsByTagName("img")[0].getAttribute("title");
    //   } else {
    //     this.copySrc = "";
    //   }
    // },
    createEditor() {
      const editor = new wangEditor(`#wangEditor`);
      editor.config.uploadImgServer = this.action;
      editor.config.uploadImgHeaders = this.header;
      editor.config.uploadFileName = "upload";
      editor.config.pasteFilterStyle = false;
      editor.config.pasteIgnoreImg = false;
      editor.config.customAlert = () => {};
      editor.config.uploadImgHooks = {
        customInsert: async (insertImgFn, result) => {
          if (result.code === 200) {
            // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
            insertImgFn(result.data.coverImg, "");
            this.handleDynamicElements();
          }
        },
      };
      editor.config.height = 700;
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = (newHtml) => {
        this.editorData = newHtml;
      };
      // 粘贴的钩子
      editor.config.pasteTextHandle = (newHtml) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(newHtml, "text/html");
        const images = doc.getElementsByTagName("img");
        for(let i = 0; i < images.length; i++) {
          let src = images[i].getAttribute("src");
          let originSrc = images[i].getAttribute("alt");
          setTimeout(() => {
            this.processImages(src, originSrc);
          }, 500);
        }
        return newHtml;
      };
      // 创建编辑器
      editor.create();
      if (this.richText != "" && this.richText != "") {
        editor.txt.html(this.richText);
      }
      this.editor = editor;
      this.handleDynamicElements();
    },
    processImages(src, originSrc) {
      const images = this.$refs.content.querySelectorAll("img[src]");
      images.forEach((img) => {
        if (img.getAttribute("src") == src) {
          img.setAttribute("origin-src", originSrc);
          img.setAttribute("alt", originSrc);
        }
      });
    },
    // **** 图片解密处理图片 start！！！
    async handleDynamicElements() {
      await this.$nextTick();
      const imgs = this.$refs.content.getElementsByTagName("img");
      this.observeImages(imgs);
    },
    observeImages(imgs) {
      // 先移除原来的监听
      this.unobserveImages();
      if (!imgs) return;
      for (let index = 0; index < imgs.length; index++) {
        const element = imgs[index];
        if (element.getAttribute("origin-src")) continue;
        element.setAttribute("alt", "");
        observer.observe(element);
        observedElements.push(element);
      }
    },
    async observeEntry(entry) {
      const { intersectionRatio } = entry;
      if (intersectionRatio <= 0) return;
      const target = entry.target;
      let tempSrc = target.getAttribute("src");
      if (!tempSrc) {
        // 没有临时路径，清除监听
        this.unobserveEntry(entry);
        return;
      }
      if (isBlobUrl(tempSrc)) {
        this.unobserveEntry(entry);
        return;
      }
      try {
        let resultSrc = this.handleImageUrl(tempSrc);
        const { url } = await videoApi.imgDecyptApi(resultSrc);
        console.log("url:", url);
        target.style.minHeight = target.style.minHeight || "auto";
        target.style.maxWidth = target.style.maxWidth || "100%";
        target.setAttribute("src", url);
        target.setAttribute("origin-src", tempSrc);
        target.setAttribute("alt", tempSrc);
        this.unobserveEntry(entry);
      } catch (error) {
        console.error("img decypt error:", error);
      }
    },
    handleImageUrl(val) {
      if (val.indexOf("http") === 0) {
        val = "/" + val.split("/").slice(3).join("/");
      } else if (val.indexOf("/") !== 0) {
        val = "/" + val;
      }
      // 根据去掉域名后的数据进行匹配
      let strValue = "";
      let data = JSON.parse(JSON.parse(localStorage.getItem("imageUrl")));
      for (const key in data) {
        if (key.indexOf("/") !== 0 && key !== "*") {
          //如果匹配键名前面不带'/'
          if (val.indexOf("/" + key + "/") === 0) {
            //
            strValue = data[key];
          }
        } else if (key.indexOf("/") === 0 && key !== "*") {
          //带'/'
          if (val.indexOf(key + "/") === 0) {
            //有匹配的
            strValue = data[key];
          }
        }
      }
      if (strValue) {
        return strValue + val;
      } else {
        return data["*"] + val;
      }
    },
    unobserveImages() {
      observedElements.forEach((v) => observer.unobserve(v));
      observedElements.splice(0);
    },
    unobserveImage(img) {
      observer.unobserve(img);
      const idx = observedElements.indexOf(img);
      if (idx >= 0) {
        observedElements.splice(idx, 1);
      }
    },
    unobserveEntry(entry) {
      this.unobserveImage(entry.target);
    },
    // **** 图片解密处理图片 end！！！
    // 打开编辑视频弹窗、传递需要编辑的参数
    async open(video) {
      this.dialogVisible = true;
      this.video = video;
      this.id = video.id;
      if (video.rich_text && video.rich_text != "") {
        this.richText = video.rich_text;
        // this.richText = video.rich_text.replace(
        //   /<img src="/g,
        //   `<img src="${ resourceHost }`
        // );
      }
      //处理复制图文业务
      var cope_rich_text = "<p>";
      if (video.title !== "") {
        cope_rich_text += video.title;
        cope_rich_text += "<br/><br/>";
      }
      if (video.content !== "") {
        cope_rich_text += video.content;
      }
      if (video.pics !== "" && video.pics !== null && video.pics !== undefined) {
        var pics = video.pics.split(",")
        if (pics.length > 0);
        for (const p of pics) {
          cope_rich_text += `<br/><br/><img src="`;
          cope_rich_text += p;
          cope_rich_text += '"/><br/><br/>';
        }
      }
      if (cope_rich_text !== "<p>") {
        this.cope_rich_text = cope_rich_text;
      }
      await this.$nextTick();
      this.createEditor();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.editor && this.editor.destroy();
      this.editor = null;
      this.cleanData();
    },
    handleAddImgClose() {
      this.dialogVisibleAddImg = false;
      this.data = "";
      this.editParam = {
        imgUrl: baseConfig.imgUrl,
        cover: "",
      };
    },
    openAddImg() {
      this.dialogVisibleAddImg = true;
    },
    cleanData() {
      this.id = "";
      this.richText = "";
      this.cope_rich_text = "";
      this.video = null;
    },
    openLook() {
      this.dialogVisibleLook = true;
      this.data = this.editor.txt.html();
      this.$refs.preview.open(this.richText, false);
    },
    handleSubmit() {
      this.data = this.editor.txt.html();
      if (!this.data) {
        alert("保存内容为空");
        return;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.data, "text/html");
      const images = doc.getElementsByTagName("img");
      for (const img of Array.from(images)) {
        const src = img.getAttribute("alt");
        if (src) {
          img.setAttribute("src", src);
          img.removeAttribute("origin-src");
        }
        img.setAttribute("alt", "");
      }
      this.data = doc.body.innerHTML;
      this.submitDate();
    },
    async handleCope() {
      this.richText = this.cope_rich_text;
      this.editor.destroy();
      this.editor = null;
      this.$nextTick();
      this.createEditor();
    },
    // 保存
    submitDate() {
      if (this.data == null || this.data == "") {
        alert("保存内容为空");
        return;
      }
      if (this.video == null || this.video == "") {
        alert("保存内容异常");
        return;
      }
      if (this.id == null || this.id == "") {
        alert("编辑帖子id异常！");
        return;
      }
      //编辑
      const params = this.video;
      params.id = this.id;
      params.rich_text = this.data;
      // params.type = 2;
      if (this.isDataFill) {
        API.taskFillingSave({
          rich_text: this.data,
          id: this.id,
        }).then((res) => {
            if (res.code === 0) {
            this.$message({
              message: "保存成功！",
              type: "success",
            });
            this.$emit("handlerLoadList");
          } else {
            this.$message.error(res.msg || res.tip || "保存失败！");
          }
          this.handleClose();
        })
        .catch((e) => {
          console.error(e);
        });
      } else {
        API.updateVideoDatav(params).then((res) => {
            if (res.code === 0) {
            this.$message({
              message: "保存成功！",
              type: "success",
            });
            this.$emit("handlerLoadList");
          } else {
            this.$message.error(res.msg || res.tip || "保存失败！");
          }
          this.handleClose();
        })
        .catch((e) => {
          console.error(e);
        });
      }
    },
    async updateFile(file) {
      const form = new FormData();
      form.append("upload", file.file);
      const { data } = await API.fileUpload(form);
      this.editParam.cover = data.coverImg;
    },
    imageUploadSuccess(res) {
      if (res.code === 200) {
        this.editParam.cover = res.data.coverImg;
      } else {
        this.$message.error(res.data);
      }
    },
    imageUploadFail(res) {
      this.$message.error(res.message);
    },
  },
};
</script>

<style lang="scss" scoped>
.wangEditor {
  ::v-deep img {
    //width: 100%;
    min-height: 200px;
  }
}
</style>
